// extracted by mini-css-extract-plugin
module.exports = {"closePopupButton":"TemplatesWizard_closePopupButton__3-aUv","popupWrapper":"TemplatesWizard_popupWrapper__1Me-t"};